module.exports = __webpack_public_path__ + "media/images/common/ico-twitter-ae5bdfd313e2002ed38937954a5f9d09.svg";